import React from "react";
import {Box, CircularProgress, Grid} from "@material-ui/core";
import upperFirst from "mn-utils/upperFirst";

import ButtonBack from "../../../dumb/Button/BackB";
import {backLocation, pushLocation} from "../../../../router";
import Caption from "../../../dumb/Caption/C";
import ButtonDownload from "../../../dumb/Button/DownloadA";
import {DetailedDataPrimaryDisplay, DetailedDataSecondaryDisplay} from "../../../helpers/Display/DetailedData";
import {
  DisplayAmountMerchant,
  DisplayDataMerchant,
  DisplayIdMerchant
} from "../../../helpers/Display/DataDisplay";
import {DisplayHashMerchant} from "../../../dumb/DisplayData";
import withState from "../../../../utils/withState";
import filter from "mn-utils/filter";
import handleDBItemData from "./utils/handleDBItemData";
import generateReceipt from "./utils/generateReceipt";
import Divider from "@material-ui/core/Divider";
import {BtnBlueFilled, BtnRedFilled, Ripple} from "../../../helpers/Buttons";
import {LINK_PBL, LINK_TRANSACTION_REFUND} from "../../../../constants/links";
import RefundList from "./RefundList";
import openPopupCancel from "./openPopupCancel";
import {apiV2GetRefundDetails, apiV2RefundEdit} from "../../../../api/merchant/refunds";
import {useDialog} from "../../../smart/DialogProvider";
import {FormFooterMerchant, FormWrapper} from "../../../helpers/FormHandlers";
import {object, string} from "yup";
import {MerchantInput, MerchantRequestError} from "../../../helpers/InputsHelpers";
import Cross from "../../../icons/Cross";
import {MerchantPageHeader} from "../../../helpers/Display";
import {DialogHeader} from "../../../helpers/Dialog";

const TrxDetailsHeader = ({handlePrint}) => (
  <MerchantPageHeader
    title="Refund details"
    backFN={backLocation}
    rightBlock={(
      <Box>
        <ButtonDownload
          onClick={handlePrint}
          name="Download Receipt"
        />
      </Box>
    )}
  />
);

const TrxDetailsPrimaryData = ({data}) => {
  const itemsParamsList = [
    {
      title: 'Refund type',
      dataHandler: ({kind}) => upperFirst(kind || '').split('_').join(' '),
    },
    {
      title: 'Status',
      dataHandler: ({status = ''}) => (
        <div className={`fw7 cFFBF43.pending c2CE889.completed
                cEE4F4F.canceled c9C8FFF.requested ` + status}
        >{upperFirst(status)}</div>
      ),
    },
  ];


  return (
    <DetailedDataPrimaryDisplay
      data={data}
      itemsParamsList={itemsParamsList}
    />
  )
};

const TrxDetailsSecondaryData = ({data}) => {
  const itemsParamsList = [
    {
      title: 'Refund ID',
      skip: ({refundId}) => !refundId,
      dataHandler: ({refundId}) => (
        <DisplayIdMerchant>{refundId}</DisplayIdMerchant>
      )
    },
    {
      title: 'Order ID',
      skip: ({orderId}) => !orderId,
      dataHandler: ({orderId}) => (
        <DisplayIdMerchant>{orderId}</DisplayIdMerchant>
      )
    },
    {
      title: 'Transaction Hash',
      skip: ({hash}) => !hash,
      dataHandler: ({hash, cryptoCurrencyCode}) => (
        <DisplayHashMerchant
          symbol={cryptoCurrencyCode}
          hash={hash}
        />
      )
    },
    {
      title: 'Amount (fiat)',
      dataHandler: ({fiatAmount, fiatCode}) => (
        <DisplayAmountMerchant
          amount={fiatAmount}
          symbol={fiatCode}
          type="fiat"
        />
      )
    },
    {
      title: 'Amount (crypto)',
      dataHandler: ({assetAmount, assetCode}) => (
        <DisplayAmountMerchant
          amount={assetAmount}
          symbol={assetCode}
          type="crypto"
        />
      )
    },
    {
      title: 'Network',
      skip: ({network, cryptoCurrencyCode, BPaySymbol}) => {
        return !network || cryptoCurrencyCode === BPaySymbol;
      },
      key: 'network'
    },
    {
      title: 'Customer email',
      dataHandler: ({email}) => (
        <DisplayDataMerchant>
          {email}
        </DisplayDataMerchant>
      ),
    },
    {
      title: 'Customer name',
      dataHandler: ({name}) => (
        <DisplayDataMerchant>
          {name}
        </DisplayDataMerchant>
      )
    }
  ]

  return (
    <DetailedDataSecondaryDisplay
      data={data}
      itemsParamsList={itemsParamsList}
    />
  )
};



const EditRefundBtn = ({data, updateData}) => {
  const [openDialog, closeDialog] = useDialog();
  return (
    <BtnBlueFilled
      onClick={() => {
        openDialog({
          maxWidth: 'md',
          fullWidth: true,
          children: (
            <Box pt="2rem" px="3rem" pb="3rem">
              <FormWrapper
                data={{
                  email: data.email,
                  name: data.name
                }}
                onSubmit={(res) => apiV2RefundEdit({
                  refund_id: data.refundId,
                  email: res.email,
                  name: res.name || ''
                })}
                onResult={() => updateData().then(closeDialog)}
                schema={
                  object({
                    email: string().isValidEmail().required(),
                    name: string().required(),
                  })
                }
                resultModalData={[`${data.refundId} has been updated`]}
              >
                {(formCtx) => (
                  <>
                    <DialogHeader
                      title="Edit refund"
                      formCtx={formCtx}
                      closeDialog={closeDialog}
                    />
                    <Box mt="2.5rem">
                      <Grid container spacing={2}>
                        <Grid item sm={6} xs={12}>
                          <MerchantInput
                            label="Customer email"
                            name="email"
                            formCtx={formCtx}
                          />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                          <MerchantInput
                            label="Customer name"
                            name="name"
                            formCtx={formCtx}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                    <Box maxWidth="60rem" mt="3.5rem">
                      <FormFooterMerchant
                        spacing={2}
                        submitBtnData={{
                          text: 'Save changes',
                          formCtx
                        }}
                        additionalBtnsList={[
                          {
                            text: 'Cancel',
                            onClick: closeDialog
                          }
                        ]}
                      />
                    </Box>
                  </>
                )}
              </FormWrapper>
            </Box>
          )
        });
      }}
    >Edit Refund</BtnBlueFilled>
  )
};

export default withState((setState, self, onMount) => {

  self.state = {
    ...self.state,
    loading: true
  }

  const updateData = () => {
    const params = self.props.params || {};

    return apiV2GetRefundDetails(filter({
      id: params.id,
    })).then(handleDBItemData).then((data) => setState({data, loading: false}));
  }

  onMount(() => {
    updateData();
  });

  const handlePrint = () => {
    setState({
      loading: true,
    });

    const data = self.state.data || {};

    generateReceipt(data).finally(() => {
      setState({
        loading: false,
      });
    });
  }

  return (state, props) => {
    if (state.loading) {
      return (
        <Box>
          <CircularProgress size="2.5rem" color="inherit" />
        </Box>
      )
    }

    const data = state.data || {};

    const showRefundActions = data.status === 'requested';

    return (
      <>
        <TrxDetailsHeader handlePrint={handlePrint} />
        <Box mt="3.5rem">
          <TrxDetailsPrimaryData data={data} />
        </Box>
        <Box mt="3rem" mb="4.5rem">
          <Divider />
        </Box>
        <Box>
          <TrxDetailsSecondaryData data={data} />
        </Box>
        {showRefundActions && (
          <Box maxWidth="60rem" mt="4.5rem">
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <EditRefundBtn
                  data={data}
                  updateData={updateData}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <BtnRedFilled
                  onClick={() => {
                    openPopupCancel(
                      data.refundId,
                      updateData
                    )
                  }}
                >
                  Cancel
                </BtnRedFilled>
              </Grid>
            </Grid>
          </Box>
        )}
      </>
    )
  }
})
